module.exports = __webpack_public_path__ + "media/application/images/ui/badge-peoples-choice-small-717dc7ae26b5ab198ff737f0b594a739.png";